/* eslint-disable */
import { useEffect, useState } from "react";
import { Box, Button, IconButton, Stack, styled, Switch, TextField, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import { useApolloClient, useLazyQuery, useMutation } from "@apollo/client";
import { emailCheck, uptimeGmailDelete, uptimeMonitoring } from "../../gql/mutations/uptimeMonitoring";
import { usePopup } from "../../context/commonPop";
import { getUptimeProject } from "../../gql/queries/uptimeStatus";
import { GetUserWebsiteData } from "../../hooks/userWebsiteData";
import useQuery from "../../hooks/allQuery";
import DashboardCard from "../shared/DashboardCard";
import DeleteEmailPopup from "../Modal/components/DeleteEmailPopup";
import { Navigate } from "react-router";
import { invalid } from "moment/moment";

const BoxWrapper = styled(Box)(({ theme }) => ({
  "& .InputWrapper": {
    marginTop: "10px",
    "& p": {
      marginBottom: "6px",
    },
    "& .MuiFormControl-root": {
      "& label": {
        "&[data-shrink='false']": {
          top: "-4px",
          color: "#7e7e7e",
        },
      },
    },
  },
}));

function UptimeMonitoringSetting({ projectid }) {
  const [isMonitoringOn, setIsMonitoringOn] = useState(false);
  const [gmailInput, setGmailInput] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [gmails, setGmails] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const { handleOpen } = usePopup();
  const { allQueryObject } = useQuery();
  const client = useApolloClient();
  const [updateUptime] = useMutation(uptimeMonitoring, { fetchPolicy: "network-only" });
  const [ValidateEmail] = useLazyQuery(emailCheck, { fetchPolicy: "network-only" });
  const [GET_UPTIME_PROJECT] = useLazyQuery(getUptimeProject, { fetchPolicy: "network-and-cache" });
  const [deleteEmailMutation] = useMutation(uptimeGmailDelete);
  const { ProjectData } = GetUserWebsiteData(projectid);
  if (ProjectData === null) {
    return <Navigate to={"/"} />;
  }
  const { userData } = useSelector(state => state.reducer);
  const { website } = ProjectData || {};

   const validateEmail = email => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email); 
 
  
 
  const getData = () => {
    allQueryObject({
      QUERY: GET_UPTIME_PROJECT,
      variables: { projectId: projectid },
      onCompleteFunc: ({ GetUptime }) => {
        setIsMonitoringOn(GetUptime?.isMonitoring || false);
        setGmails(GetUptime?.gmails || []);
      },
      onErrorFunc: error => {
        console.error("Error fetching uptime data:", error);
        handleOpen(true, error.message || "Something went wrong");
      },
    });
  };

  const handleSwitchChange = async () => {
    if (!website) return;

    const gmailsArray = gmailInput
      .split(",")
      .map(email => email.trim())
      .filter(email => email);
    if (!gmailsArray.every(validateEmail)) {
      setEmailError(true);
      return;
    }

    try {
      await updateUptime({
        variables: {
          data: {
            userId: userData.id,
            projectId: projectid,
            isMonitoring: !isMonitoringOn,
            domain: website.split("/")[2],
            gmails: !isMonitoringOn ? gmailsArray : [],
          },
        },
      });
      setIsMonitoringOn(prev => !prev);
      if (!isMonitoringOn) {
        setGmails(gmailsArray);
      } else {
        setGmails([]);
      }

      getData();
      setGmailInput("");
      updateCacheAfterSwitch();
      handleOpen(true, isMonitoringOn ? "Successfully ended uptime monitoring" : "Successfully started uptime monitoring");
    } catch (error) {
      console.error("Error updating uptime:", error);
      handleOpen(true, "Failed to update isMonitoring state!");
    }
  };

  const updateCacheAfterSwitch = (newMonitoringState, newGmails) => {
    const updateCache = (query, variables, getUpdatedData) => {
      const cacheData = client.readQuery({ query, variables });
      if (cacheData) {
        client.writeQuery({
          query,
          variables,
          data: getUpdatedData(cacheData),
        });
      }
    };

    updateCache(getUptimeProject, { projectId: projectid }, cacheData => ({
      ...cacheData,
      GetUptime: {
        ...cacheData.GetUptime,
        isMonitoring: newMonitoringState,
        gmails: newMonitoringState ? newGmails : [],
      },
    }));
  };

 const validateEmails = async email => {
   try {
     const { data } = await ValidateEmail({
       variables: { email },
       fetchPolicy: "network-only",
     });

     if (data?.validateEmail?.valid) {
       return { isValid: true, reason: null };
     } else {
       return { isValid: false, reason: "Invalid email address" };
     }
   } catch (error) {
     console.error("Email validation error:", error);
     return { isValid: false, reason: "Validation failed" };
   }
 };

  const handleAddOrUpdateGmail = async () => {
    if (!validateEmail(gmailInput)) {
      setEmailError("Invalid email format.");
      return;
    }

    const validationResult = await validateEmails(gmailInput);
    if (!validationResult.isValid) {
      setEmailError(`${validationResult.reason}`);
      return;
    }

   if (gmails.includes(gmailInput) && (editIndex === null || gmails[editIndex] !== gmailInput)) {
     handleOpen(true, "Gmail already exists");
     return;
   }

    const updatedGmails = [...gmails];
    if (editIndex !== null) {
      updatedGmails[editIndex] = gmailInput;
    } else {
      updatedGmails.push(gmailInput);
    }

    setGmails(updatedGmails);
    setEditIndex(null);
    setGmailInput("");
    setEmailError("");

    try {
      await updateUptime({
        variables: {
          data: {
            userId: userData.id,
            projectId: projectid,
            isMonitoring: isMonitoringOn,
            domain: website.split("/")[2],
            gmails: updatedGmails,
            updateIndex: editIndex,
            newGmail: gmailInput,
          },
        },
      });
      handleOpen(true, editIndex !== null ? "Email address updated successfully!" : "Email address add successfully!");
    } catch (error) {
      console.error("Error updating uptime email:", error);
      handleOpen(true, error.message || "Something went wrong");
    }
  };

  const handleEditGmail = index => {
    setEditIndex(index);
    setGmailInput(gmails[index]);
  };

  const handleDeleteGmail = async index => {
    const updatedGmails = gmails.filter((_, i) => i !== index);
    setGmails(updatedGmails);
    if (editIndex === index) {
      setEditIndex(null);
      setGmailInput("");
    }

    try {
      await deleteEmailMutation({
        variables: { projectId: projectid, index },
      });
      setOpen(false);
    } catch (error) {
      console.error("Error deleting email:", error);
      handleOpen(true, error.message || "Something went wrong");
    }
  };

  const handleOpenDeletePopup = index => {
    setSelectedIndex(index);
    setOpen(true);
  };

  useEffect(() => {
    if (projectid) getData();
  }, [projectid]);

  return (
    <DashboardCard className="HeightFull">
      <BoxWrapper>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography>Uptime monitoring {isMonitoringOn ? "On" : "Off"}</Typography>
          <Switch checked={isMonitoringOn} onChange={handleSwitchChange} inputProps={{ "aria-label": "ant design" }} />
        </Stack>
        <Box className="InputWrapper" style={{ marginTop: "16px" }}>
          <Typography component="p">Notification emails for uptime monitoring</Typography>
          <TextField
            label="Enter an email address"
            type="email"
            value={gmailInput}
            onChange={e => {
              const email = e.target.value;
              setGmailInput(email);
              setEmailError(email && !validateEmail(email) ? "Please enter a valid email address." : "");
            }}
            fullWidth
            error={!!emailError}
            helperText={emailError}
          />
          <Button variant="contained" color="primary" onClick={handleAddOrUpdateGmail} disabled={emailError || gmailInput.trim() === ""} style={{ marginTop: "16px" }}>
            {editIndex !== null ? "Update" : "Save"}
          </Button>
          {gmails.length > 0 && (
            <Box style={{ marginTop: "10px" }}>
              {gmails.map((email, index) => (
                <Stack direction="row" spacing={1} alignItems="center" key={index} style={{ marginBottom: "10px" }}>
                  <Typography>{email}</Typography>
                  <IconButton onClick={() => handleEditGmail(index)} color="primary">
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error">
                    <CancelIcon
                      onClick={() => handleOpenDeletePopup(index)}
                      sx={{
                        mr: "25px",
                        cursor: "pointer",
                      }}
                    />
                  </IconButton>
                </Stack>
              ))}
            </Box>
          )}
        </Box>
      </BoxWrapper>
      <DeleteEmailPopup setOpen={setOpen} open={open} onSubmit={() => handleDeleteGmail(selectedIndex)} />
    </DashboardCard>
  );
}

export default UptimeMonitoringSetting;
